import { PrepReviewCtrl } from './prep-review.controller';

export const PrepReviewComponent = {
  controller: PrepReviewCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./prep-review.html'),
};
